import React from 'react';
import { Tooltip, Typography } from '@usepepper/sprout-kit-ui';

interface Props
  extends Omit<
    React.ComponentProps<typeof Typography>,
    'children' | 'numberOfLines'
  > {
  text: string;
}

export const FinanceHubTableTooltipTextCell: React.FC<Props> = ({
  text,
  ...typographyProps
}) => (
  <Tooltip placement="top">
    <Tooltip.Trigger>
      <Typography numberOfLines={1} {...typographyProps}>
        {text}
      </Typography>
    </Tooltip.Trigger>
    <Tooltip.Content>
      <Typography color="$textOnDark" size="$sm">
        {text}
      </Typography>
    </Tooltip.Content>
  </Tooltip>
);
